<template>
  <div>
    <v-navigation-drawer
      v-if="display"
      class="dark-silder"
      v-model="drawer"
      :mini-variant.sync="mini"
      dark
      expand-on-hover
      app
      right
    >
      <v-list-item class="px-2">
        <v-list-item-avatar>
          <v-img
            :src="
              require('../assets/avatar-human-male-profile-user-icon-518358.png')
            "
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-title class="text-list">{{
          $session.get("fullname")
        }}</v-list-item-title>
        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item link router>
          <v-list-item-icon>
            <v-icon>mdi-monitor-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content
            style="padding: 0px"
            @click="changePage('/dashboard')"
          >
            <v-list-item-title class="text-list">ภาพรวม</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link router>
          <v-list-item-icon>
            <v-icon>mdi-folder-upload</v-icon>
          </v-list-item-icon>
          <v-list-item-content
            style="padding: 0px"
            @click="changePage('/upload')"
          >
            <v-list-item-title class="text-list"
              ><span
                v-if="
                  $session.get('role') === 'Customer' &&
                  $session.get('status') === 1
                "
                >อัพโหลดไฟล์เอกสารโครงการ</span
              ><span v-else>อัพโหลดไฟล์เอกสาร</span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          router
          v-if="
            $session.get('role') === 'Customer' && $session.get('status') === 1
          "
        >
          <v-list-item-icon>
            <v-icon>mdi-folder-upload</v-icon>
          </v-list-item-icon>
          <v-list-item-content
            style="padding: 0px"
            @click="changePage('/uploadCertificate')"
          >
            <v-list-item-title class="text-list"
              >อัพโหลดไฟล์เอกสาร ภ.พ. 20</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link router v-if="false">
          <v-list-item-icon>
            <v-icon>mdi-help-rhombus</v-icon>
          </v-list-item-icon>
          <v-list-item-content style="padding: 0px" @click="help_dialog = true">
            <v-list-item-title class="text-list"
              >ขอความช่วยเหลือ</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link router>
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content
            style="padding: 0px"
            @click="changePage('/logout')"
          >
            <v-list-item-title class="text-list">ออกจากระบบ</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "silderbarBox",
  data: () => ({
    drawer: true,
    mini: true,
    display: false,
    help_dialog: false,
  }),
  mounted() {
    if (this.$session.get("username") !== undefined) {
      this.display = true;
    }
  },
  methods: {
    changePage: function (path_click) {
      let current_path = window.location.hash.split("#")[1];
      if (current_path !== path_click && path_click !== "/logout") {
        this.$router.push(path_click);
      } else if (path_click === "/logout") {
        this.$session.destroy();
        this.$router.push("/");
      }
    },
  },
};
</script>
<style>
.dark-silder {
  background-color: #141824 !important;
}
.theme--dark.v-icon {
  color: #ffb600 !important;
}
.text-list {
  color: #ffb600 !important;
}
</style>